/**
 * Father's Day buy box — plan card selection (Figma 79:1204).
 */
(function () {
  function selectCard(section, card) {
    var cards = section.querySelectorAll('.fd-buy-box__card[data-fd-plan]');
    var ctaText = section.querySelector('.fd-buy-box__cta-text');

    cards.forEach(function (item) {
      var isSelected = item === card;
      item.classList.toggle('fd-buy-box__card--selected', isSelected);
      item.setAttribute('aria-current', isSelected ? 'true' : 'false');
      item.setAttribute('aria-expanded', isSelected ? 'true' : 'false');

      var radio = item.querySelector('.fd-buy-box__card-radio');
      if (radio) {
        radio.classList.toggle('fd-buy-box__card-radio--on', isSelected);
      }

      var tab = item.querySelector('.fd-buy-box__card-tab');
      if (tab) {
        tab.hidden = !isSelected;
      }
    });

    if (ctaText && card.dataset.fdCta) {
      ctaText.textContent = card.dataset.fdCta;
    }
  }

  function initBuyBox(section) {
    if (!section || section.dataset.fdBuyBoxInit) {
      return;
    }
    section.dataset.fdBuyBoxInit = '1';

    var cards = section.querySelectorAll('.fd-buy-box__card[data-fd-plan]');
    if (!cards.length) {
      return;
    }

    cards.forEach(function (card) {
      card.setAttribute('tabindex', '0');

      card.addEventListener('click', function (event) {
        if (event.target.closest('a')) {
          return;
        }
        selectCard(section, card);
      });

      card.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') {
          return;
        }
        event.preventDefault();
        selectCard(section, card);
      });
    });
  }

  function init() {
    document.querySelectorAll('.fd-buy-box').forEach(initBuyBox);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
